import { render, staticRenderFns } from "./StudentstatisticsNoSubordinate_shqp.vue?vue&type=template&id=4c774589"
import script from "./StudentstatisticsNoSubordinate_shqp.vue?vue&type=script&lang=js"
export * from "./StudentstatisticsNoSubordinate_shqp.vue?vue&type=script&lang=js"
import style0 from "./StudentstatisticsNoSubordinate_shqp.vue?vue&type=style&index=0&id=4c774589&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports